export const getters = {
  getAllPractices: (state) => {
    return state.practices;
  },

  getAvailableLanguages: (state) => {
    return state.availableLanguages
  }
};
